import { ReadIntegrationsApiResponse } from '../types/messagingApi.types';

export function transformReadIntegrationsResponse(
  response: ReadIntegrationsApiResponse,
): ReadIntegrationsApiResponse {
  return {
    data: {
      // When an integration is deleted, it is still returned by the API as
      // `Activated`, but without an `integration` object, so we filter those out here
      // and treat them as deleted.
      integrations: response.data.integrations.filter(
        ({ integration, status }) =>
          status === 'Pending' || (status === 'Activated' && integration),
      ),
    },
    meta: {},
  };
}
